// extracted by mini-css-extract-plugin
module.exports = {"modal":"SentModal_modal__2wP34","icon":"SentModal_icon__E6bhQ","body":"SentModal_body__2GIxr","button":"SentModal_button__rZzlb"};